import { useLayoutEffect } from "react";

export function useStylesheet(href) {
  useLayoutEffect(() => {
    let link = document.querySelector(`link[data-stemeit-stylesheet="${href}"]`);
    if (!link) {
      link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.dataset.stemeitStylesheet = href;
      document.head.appendChild(link);
    }
  }, [href]);
}
